import { h, Component } from 'preact';

import { trackingProvider, DIMENSION } from '@cube/track';

/** Creates div for dailymotion js insertion
 * documentation: https://developers.google.com/youtube/iframe_api_reference#Examples
 */
@trackingProvider({
	[DIMENSION.componentpath]: 'Youtube'
})
export class Youtube extends Component {

	shouldComponentUpdate = () => false;

	render({ id }) {
		return (
			<iframe
				id="ytplayer"
				width="100%"
				height="100%"
				src={`https://www.youtube.com/embed/${id}?enablejsapi=1&origin=${window.location.origin}&autoplay=1`}
				frameborder="0"
				allowfullscreen
			/>
		);
	}
}
